// LateBanner — red block shown at the top of a requisition detail
export default function LateBanner({ show }) {
  if (!show) return null;
  return (
    <div
      data-testid="late-banner"
      className="mb-4 rounded-md px-4 py-3 bg-[#b3261e] text-white uppercase tracking-wider text-sm font-bold shadow-sm"
    >
      FYI: Form submitted beyond ideal timeline — Last-minute requirement
    </div>
  );
}
